import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../components/Toast';
import { useSocket } from '../../contexts/SocketContext';
import { Clock, ArrowLeft } from 'lucide-react';
import api from '../../utils/api';
import AdminNotificationBell from '../../components/AdminNotificationBell';
import TabBar from '../../components/TabBar';


// 将模板变量替换为实际时间，用于预览

export default function WorkHoursPage() {
  const navigate = useNavigate();
  const [startHour,   setStartHour]   = useState('10');
  const [startMinute, setStartMinute] = useState('0');
  const [endHour,     setEndHour]     = useState('20');
  const [endMinute,   setEndMinute]   = useState('0');
  
  const [loading,     setLoading]     = useState(false);
  const { showToast } = useToast();
  const { subscribe } = useSocket();

  const fetchSettings = useCallback(() => {
    api.get('/admin/settings/work-hours').then(res => {
      setStartHour(String(res.data.startHour));
      setStartMinute(String(res.data.startMinute));
      setEndHour(String(res.data.endHour));
      setEndMinute(String(res.data.endMinute));
      
    }).catch(() => {});
  }, []);

  useEffect(() => { fetchSettings(); }, [fetchSettings]);

  useEffect(() => {
    if (!subscribe) return;
    return subscribe((event) => {
      if (event === 'work_hours_updated') fetchSettings();
    });
  }, [subscribe, fetchSettings]);

  const handleSave = async () => {
    setLoading(true);
    try {
      await api.put('/admin/settings/work-hours', {
        startHour:      parseInt(startHour),
        startMinute:    parseInt(startMinute),
        endHour:        parseInt(endHour),
        endMinute:      parseInt(endMinute),
      });
      showToast('设置保存成功', 'success');
      fetchSettings(); // 立即刷新，不依赖 socket
    } catch (err) {
      showToast(err.response?.data?.error || '保存失败', 'error');
    } finally { setLoading(false); }
  };

  const hours   = Array.from({ length: 24 }, (_, i) => i);
  const minutes = [0, 15, 30, 45];


  return (
    <div className="page">
      <div className="header" style={{ display: 'flex', alignItems: 'center' }}>
        <button
          onClick={() => navigate(-1)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px 8px 4px 0', display: 'flex', alignItems: 'center', color: 'var(--c-primary)' }}
        >
          <ArrowLeft size={18} />
        </button>
        <span style={{ flex: 1 }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Clock size={16} /> 工作时间设置
        </span>
        </span>
        <AdminNotificationBell />
      </div>

      <div style={{ padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>

        {/* 工作时间 */}
        <div className="card">
          <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 14 }}>工作时间范围</h3>

          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--c-text-secondary)', marginBottom: 6, display: 'block' }}>
              接量开始时间 <span style={{ fontWeight: 400, fontSize: 12 }}>（用于文案提示，不限制接量）</span>
            </label>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <select className="input" value={startHour} onChange={e => setStartHour(e.target.value)} style={{ flex: 1 }}>
                {hours.map(h => <option key={h} value={h}>{String(h).padStart(2,'0')} 时</option>)}
              </select>
              <span style={{ color: 'var(--c-text-secondary)' }}>:</span>
              <select className="input" value={startMinute} onChange={e => setStartMinute(e.target.value)} style={{ flex: 1 }}>
                {minutes.map(m => <option key={m} value={m}>{String(m).padStart(2,'0')} 分</option>)}
              </select>
            </div>
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--c-text-secondary)', marginBottom: 6, display: 'block' }}>
              结束时间
            </label>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <select className="input" value={endHour} onChange={e => setEndHour(e.target.value)} style={{ flex: 1 }}>
                {hours.map(h => <option key={h} value={h}>{String(h).padStart(2,'0')} 时</option>)}
              </select>
              <span style={{ color: 'var(--c-text-secondary)' }}>:</span>
              <select className="input" value={endMinute} onChange={e => setEndMinute(e.target.value)} style={{ flex: 1 }}>
                {minutes.map(m => <option key={m} value={m}>{String(m).padStart(2,'0')} 分</option>)}
              </select>
            </div>
          </div>

          <div style={{ background: 'var(--c-primary-light)', padding: 10, borderRadius: 8 }}>
            <p style={{ fontSize: 14, textAlign: 'center' }}>
              当前设置：<strong>{String(startHour).padStart(2,'0')}:{String(startMinute).padStart(2,'0')}</strong>
              {' ~ '}
              <strong>{String(endHour).padStart(2,'0')}:{String(endMinute).padStart(2,'0')}</strong>
            </p>
            <p style={{ fontSize: 12, color: 'var(--c-text-secondary)', textAlign: 'center', marginTop: 4 }}>
              每日 00:00 起可提交接量，结束时间后不可再提交新接量，须等到次日 00:00
            </p>
          </div>
        </div>



        <button className="btn btn-primary" onClick={handleSave} disabled={loading}
          style={{ height: 48, fontSize: 15 }}>
          {loading ? '保存中...' : '保存并推送'}
        </button>
      </div>
      <TabBar mode="admin" />
    </div>
  );
}
